import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b6b6d69a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", { class: "hidden-br" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  style: {"font-family":"San Francisco Bold","color":"#fff"},
  href: "mailto:team@inksquad.com"
}, "team@inksquad.com", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleTemplate = _resolveComponent("TitleTemplate")!
  const _component_AccordionElement = _resolveComponent("AccordionElement")!
  const _component_AccordionMainElement = _resolveComponent("AccordionMainElement")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TitleTemplate, null, {
      main: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.homepage.faq.title')), 1)
      ]),
      text: _withCtx(() => [
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('components.homepage.faq.subtitle-line-1')), 1),
          _hoisted_1,
          _createTextVNode(_toDisplayString(_ctx.$t('components.homepage.faq.subtitle-line-2')), 1),
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.homepage.faq.subtitle-line-3-half-1')) + " ", 1),
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('components.homepage.faq.subtitle-line-3-half-2')), 1)
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_AccordionMainElement, { rows: _ctx.accordionRows }, {
      "1": _withCtx(() => [
        _createVNode(_component_AccordionElement, null, {
          answer: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.homepage.faq.answer-1')), 1)
          ]),
          _: 1
        })
      ]),
      "2": _withCtx(() => [
        _createVNode(_component_AccordionElement, null, {
          answer: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('components.homepage.faq.answer-2')), 1)
          ]),
          _: 1
        })
      ]),
      communications: _withCtx(() => []),
      _: 1
    }, 8, ["rows"])
  ], 64))
}